export const MIN_SEARCH_LENGTH = 3
export const FIRST_LEVEL_MARK = 1
export const SECOND_LEVEL_MARK = 2
